export const TAB_TIME_ALLOCATION = 0
export const TAB_SETTINGS = 1

//TODO: Remove this when the api is ready
export const dumpTrucksEvents = [
  {
    id: '1',
    title: 'Dump Truck - 480',
    truckName: 'Dump Truck',
    start: '2024-10-01T12:00:00'
  },
  {
    id: '2',
    title: 'Dump Truck - 480',
    truckName: 'Dump Truck',
    start: '2024-10-02T12:00:00'
  },
  {
    id: '3',
    title: 'Dump Truck - 480',
    truckName: 'Dump Truck',
    start: '2024-10-03T12:00:00'
  },
  {
    id: '4',
    title: 'Dump Truck - 480',
    truckName: 'Dump Truck',
    start: '2024-10-04T12:00:00'
  },
  {
    id: '5',
    title: 'Dump Truck - 480',
    truckName: 'Dump Truck',
    start: '2024-10-05T12:00:00'
  }
]
